export default "__VITE_ASSET__1b7f73cc__"